/** Returns IDs in the inclusive, currently loaded range between two attachment IDs. */
export function getAttachmentSelectionRangeIds<T extends Pick<{ id: number }, 'id'>>(
  items: ReadonlyArray<T>,
  anchorId: number,
  targetId: number
): number[] {
  const anchorIndex = items.findIndex((item) => item.id === anchorId);
  const targetIndex = items.findIndex((item) => item.id === targetId);
  if (anchorIndex < 0 || targetIndex < 0) return [];

  const rangeStart = Math.min(anchorIndex, targetIndex);
  const rangeEnd = Math.max(anchorIndex, targetIndex);
  return items.slice(rangeStart, rangeEnd + 1).map((item) => item.id);
}
